import { isWeb, tva } from "@gluestack-ui/utils";

const baseStyle = isWeb
	? "tracking-sm my-0 bg-transparent border-0 box-border display-inline list-none margin-0 padding-0 position-relative text-start no-underline whitespace-pre-wrap word-wrap-break-word"
	: "";

const BRAND_LINE_HEIGHT = {
	"4xl": "leading-normal web:leading-none",
	"7xl": "leading-snug",
	"8xl": "leading-snug",
} as const;

const brandLineHeights = Object.entries(BRAND_LINE_HEIGHT).map(([size, className]) => ({
	variant: "brand" as const,
	size: size as keyof typeof BRAND_LINE_HEIGHT,
	class: className,
}));

export const textStyle = tva({
	base: `text-neutral-950 ${baseStyle}`,
	variants: {
		variant: {
			primary: "font-sans",
			brand: "font-brand",
		},
		isTruncated: {
			true: "web:truncate",
		},
		medium: {
			true: "font-sans-medium web:font-medium",
		},
		bold: {
			true: "font-sans-bold web:font-bold",
		},
		semiBold: {
			true: "font-sans-semibold web:font-semibold",
		},
		extraBold: {
			true: "font-sans-extrabold web:font-extrabold",
		},
		underline: {
			true: "underline",
		},
		strikeThrough: {
			true: "line-through",
		},
		size: {
			"2xs": "text-2xs",
			xs: "text-xs",
			sm: "text-sm",
			md: "text-base",
			lg: "text-lg",
			xl: "text-xl",
			"2xl": "text-2xl",
			"3xl": "text-3xl",
			"4xl": "text-4xl",
			"5xl": "text-5xl/snug",
			"6xl": "text-6xl/snug",
			"7xl": "text-7xl/tight",
			"8xl": "text-8xl/tight",
		},
		sub: {
			true: "text-xs",
		},
		italic: {
			true: "italic",
		},
		highlight: {
			true: "bg-primary-500",
		},
	},
	compoundVariants: [
		// The brand font is a single family, so weight variants must not swap it
		// out for the sans family.
		{
			variant: "brand",
			medium: true,
			class: "font-brand",
		},
		{
			variant: "brand",
			semiBold: true,
			class: "font-brand",
		},
		{
			variant: "brand",
			bold: true,
			class: "font-brand",
		},
		...brandLineHeights,
	],
});
